import axios from "../axios";
import moment from "moment";
import momentTz from "moment-timezone";
/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload);
  },

  async getCustomerStatus({ commit }) {
    let res = await axios().get("/api/customer/status");

    commit("setCustomerStatus", res.data);
  },

  async getContracts({ commit }) {
    let res = await axios().get("/api/contracts");

    let contracts = res.data;
    contracts.forEach(contract => {
      contract.start_date = moment(contract.start_date)
        .locale("nl")
        .format("LL");
      contract.date = moment(contract.date)
        .locale("nl")
        .format("LL");
      contract.end_date =
        contract.end_date != null
          ? moment(contract.end_date)
              .locale("nl")
              .format("LL")
          : null;
    });
    commit("setContracts", contracts);
  },
  async getMutationRequests({ commit }) {
    let res = await axios().get("/api/mutationrequests");

    let mutationRequests = res.data;
    mutationRequests.forEach(mutationRequest => {
      let time = moment(mutationRequest.time);
      let tz = momentTz.tz.guess();
      time = time.tz(tz);
      mutationRequest.time = time.locale("nl").format("LL");
    });
    commit("setMutationRequests", mutationRequests);
  },
  async getCustomer({ commit }) {
    let res = await axios().get("/api/customer");

    let customer = res.data;
    commit("setCustomer", customer);
  },
  async getActions({ commit }) {
    let res = await axios().get("/api/actions");

    let actions = res.data;
    commit("setActions", actions);
  }
};

export default actions;
